import { ButtonProps, IconButton } from '@chakra-ui/react';
import { Tooltip } from '../ui/tooltip';
import { FC } from 'react';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { useBackNavigate } from '../../hooks/useBackNavigate';
import { MIcon } from './chakra';

interface MBackButtonProps {
  /**
   * Only for non-navigational uses (e.g. collapsing an expanded search input).
   * Page headers intentionally leave this unset: the back button mirrors the
   * browser's own back button, falling back to the dashboard only when there
   * is no history to return to. It must not target a hardcoded route.
   */
  onClick?: () => void;
  containerProps?: ButtonProps;
}

export const MBackButton: FC<MBackButtonProps> = ({
  onClick,
  containerProps,
}: MBackButtonProps) => {
  const { navigateBack } = useBackNavigate();

  return (
    <Tooltip content="Back">
      <IconButton
        variant="icon"
        aria-label="Back"
        data-testid="pageHeader-back"
        onClick={onClick ?? navigateBack}
        size="sm"
        _hover={{ color: 'tPurple.base', bg: 'tBlue.hover' }}
        _active={{ bg: 'tGray.lightPurple' }}
        {...containerProps}
      >
        <MIcon as={MdKeyboardArrowLeft} w={6} h={6} color="tGray.darkPurple" />
      </IconButton>
    </Tooltip>
  );
};
